import {combineReducers} from "redux";
import companyInfo from './companyInfoReducer'

const reducers = combineReducers({
    companyInfo
});

export default reducers;
